<template>
  <v-container fluid tag="section">
      <base-material-dialog
        title='专利编辑'
        :dialog="item.show"
        v-bind="$attrs"
        @on-dialog-change='dialogChange'
        max-width='550'
        persistent
      >
        <template v-slot:content>
          <v-card class="px-3" elevation="0">
            <v-form ref="form" lazy-validation>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field hide-details="auto" label="专利名称" outlined :rules="required" placeholder="请输入专利名称" v-model="form.name"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field hide-details="auto" label="申请人" outlined :rules="required" placeholder="请输入申请人名称" v-model="form.applyUser"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                      hide-details="auto"
                      outlined
                      v-model="form.patentType"
                      :rules="required"
                      :items="patentTypeItem"
                      item-text="label"
                      item-value="value"
                      label="专利类型"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field hide-details="auto" label="第一发明人姓名"  outlined :rules="required" placeholder="请输入第一发明人姓名" v-model="form.firstInventorName"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field hide-details="auto" label="第一发明人身份证号"  outlined :rules="required" placeholder="请输入第一发明人身份证号" v-model="form.firstInventorCard"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field label="其他发明人姓名" hide-details="auto" outlined :rules="required" placeholder="请输入其他发明人,以逗号分隔" v-model="form.otherInventorName"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text class="text--disabled" @click='item.show = false'>
                关闭
              </v-btn>
              <v-btn color="primary" :loading="loading" @click='save'>
                保存
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { edit } from '@/api/patent/index.js'

  export default {
    name: 'PatentEdit',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null,
          add: false
        })
      }
    },
    data() {
      return {
        patentTypeItem: [
          { label: '实用新型', value: 1 },
          { label: '发明专利', value: 2 },
          { label: '外观专利', value: 3 }
        ],
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        number: [
          value => !!value || '此项为必填项!',
          value => /^[1-9]+.?[1-9]*$/.test(value) || '必须输入数字',
        ],
        form: {
          id: '',
          name: '',
          applyUser: '',
          signUserId: '',
          contractId: '',
          firstInventorName: '',
          firstInventorCard: '',
          patentType: '',
          otherInventorName: ''
        },
        defForm: {
          id: '',
          name: '',
          signUserId: '',
          contractId: '',
          firstInventorName: '',
          firstInventorCard: '',
          patentType: '',
          otherInventorName: ''
        }
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.loading = true
          if (this.item.add) { this.form.id = '' }
          edit(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          this.form = JSON.parse(JSON.stringify(this.item.data))
        } else {
          this.form = JSON.parse(JSON.stringify(this.defForm))
        }
      }
    }
  }
</script>

<style lang="sass">
  #system-user-detail-page
</style>
